export default __webpack_public_path__ + "static/jameson-104845500155b165a98d1b14bf5c98e6.png";